module.exports = "<div> {%- value %} </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/asns/detailPageLookupHTML/serviceLookupMultiRowsColumns.html
// module id = 1242
// module chunks = 1